module.exports = __webpack_public_path__ + "img/exposicaoPermanente.f904eebe.svg";